import { MonetaryAmount } from "../../app/domain/monetary-amount";
import auth0Client from "../../app/auth/Auth";
import { addContextLog } from "../../infrastructure/log";
import { updateAlertThreshold } from "../../infrastructure/repository/company-repository";
import { translate } from "../../infrastructure/translate/localization";
import { showErrorMessage } from "../commons/show-error-message";
import { showSuccessMessage } from "../commons/show-success-message";
import { displayBalance } from "./display-balance";

export default async function changeAlertThreshold({
  amount,
  emails,
}: {
  amount: MonetaryAmount;
  emails: string[];
}): Promise<void> {
  const companyId = auth0Client.getCompanyId();
  addContextLog("info", "setBalanceAlert", "process", {
    companyId,
    amount,
    emails,
  });
  const data = await updateAlertThreshold({ companyId, amount, emails });
  if (data.status === 200) {
    showSuccessMessage(translate("my-account-section.updated-amount"));
    displayBalance();
  } else if (data.status === 422) {
    showErrorMessage(
      translate("common-messages.error-message-due-to-incorrect-parameters")
    );
  } else {
    showErrorMessage(translate("common-messages.basic-error-message"));
  }
}
